module.exports = __webpack_public_path__ + "img/sshx1.df3aedb3.png";